module.exports = __webpack_public_path__ + "img/elo.0e484c8.png";